export const getIdEstadoFromNombre = (estado) => {
    const estadosMap = {
        activo: 1,
        inactivo: 2,
        pendiente_activacion: 3
    };

    return estadosMap[estado.toLowerCase()] ?? null;
};